import App from './App';
import { ROUTES, SCREEN_TYPE } from '@shared/configs/constants';
import MainPanelLayout from '@user/layouts/MainPanelLayout';
import { HomePage, PublicationsPage, PublicationDetailPage, MagazinesPage, MagazineDetailPage, PrivacyPolicyPage, ProfilePage, TermsOfServicePage, UsageGuidePage, NotFoundPage, ProfileEditPage, PurchaseHistoryPage, PurchaseHistoryDetailPage, CartPage, CheckoutPage, PaymentResultPage, MyLibraryReadingHistoryPage, MyLibraryFavoritesPage, MyLibraryPublicationsPage, VerifyEmailChangePage, LoginSSOPage } from '@user/pages';
import ProfileLayout from '@user/layouts/ProfileLayout';
import ConfirmPasswordPage from '@user/pages/forgot-password/ConfirmPasswordPage';
import ForgotPasswordPage from '@user/pages/forgot-password/ForgotPasswordPage';
import RegistrationStepOne from '@user/pages/sign-up/registration-step-one';
import RegistrationStepThree from '@user/pages/sign-up/registration-step-three';
import RegistrationStepTwo from '@user/pages/sign-up/registration-step-two';
import ReaderPage from '@user/pages/reader';
import { AuthGuard } from '@user/components/guards/AuthGuard';
import { StdIndividualGuard } from '@user/components/guards/StdIndividualGuard';
import { createBrowserRouter } from 'react-router-dom';
import withAuthenticationNotPermitted from '@/shared/hooks/withAuthenticationNotPermitted';
import NoAutht from '@/shared/layouts/NoAutht';
import { TargetServiceGuard } from './components/guards/TargetServiceGuard';
const AuthenticationNotPermitted = withAuthenticationNotPermitted(NoAutht);

export const userRouter = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                element: <MainPanelLayout />,
                children: [
                    {
                        path: ROUTES.publications.href,
                        element: <PublicationsPage />
                    },
                    {
                        path: ROUTES.ranking.href,
                        element: <PublicationsPage />
                    },
                    {
                        path: ROUTES.new.href,
                        element: <PublicationsPage />
                    },
                    {
                        path: ROUTES.recently.href,
                        element: <PublicationsPage />
                    },
                    {
                        element: <TargetServiceGuard />,
                        children: [
                            {
                                index: true,
                                element: <HomePage />
                            },
                            {
                                path: ROUTES.books.href,
                                element: <PublicationsPage />
                            },
                            {
                                path: ROUTES.magazines.href,
                                element: <MagazinesPage />
                            },
                            {
                                path: ROUTES.usageGuide.href,
                                element: <UsageGuidePage />
                            }
                        ]
                    },
                    {
                        path: ROUTES.magazineDetail.href,
                        element: <MagazineDetailPage />
                    },
                    {
                        path: ROUTES.publicationDetail.href,
                        element: <PublicationDetailPage />
                    },
                    {
                        path: ROUTES.privacyPolicy.href,
                        element: <PrivacyPolicyPage />
                    },
                    {
                        path: ROUTES.termsOfService.href,
                        element: <TermsOfServicePage />
                    },
                    {
                        element: <AuthenticationNotPermitted screenType={SCREEN_TYPE.GU} />,
                        children: [
                            {
                                path: ROUTES.forgotPassword.href,
                                element: <ForgotPasswordPage />
                            },
                            {
                                path: ROUTES.registrationStepOne.href,
                                element: <RegistrationStepOne />
                            },
                            {
                                path: ROUTES.registrationStepTwo.href,
                                element: <RegistrationStepTwo />
                            },
                            {
                                path: ROUTES.registrationStepThree.href,
                                element: <RegistrationStepThree />
                            },
                            {
                                path: ROUTES.confirmPassword.href,
                                element: <ConfirmPasswordPage />
                            },
                            {
                                path: ROUTES.verifyEmailChange.href,
                                element: <VerifyEmailChangePage />
                            }

                        ]
                    },
                    {
                        element: <AuthGuard />,
                        children: [
                            {
                                element: <StdIndividualGuard />,
                                children: [
                                    {
                                        path: ROUTES.cart.href,
                                        element: <CartPage />
                                    },
                                    {
                                        path: ROUTES.checkout.href,
                                        element: <CheckoutPage />
                                    },
                                    {
                                        path: ROUTES.paymentResult.href,
                                        element: <PaymentResultPage />
                                    }
                                ]
                            },
                            {
                                element: <ProfileLayout />,
                                children: [
                                    {
                                        path: ROUTES.profile.href,
                                        element: <ProfilePage />
                                    },
                                    {
                                        path: ROUTES.profileEdit.href,
                                        element: <ProfileEditPage />
                                    },
                                    {
                                        element: <StdIndividualGuard />,
                                        children: [
                                            {
                                                path: ROUTES.purchaseHistory.href,
                                                element: <PurchaseHistoryPage />
                                            },
                                            {
                                                path: ROUTES.purchaseHistoryDetail.href,
                                                element: <PurchaseHistoryDetailPage />
                                            }
                                        ]
                                    },
                                    {
                                        path: ROUTES.myLibraryPublications.href,
                                        element: <MyLibraryPublicationsPage />
                                    },
                                    {
                                        path: ROUTES.myLibraryReadingHistory.href,
                                        element: <MyLibraryReadingHistoryPage />
                                    },
                                    {
                                        path: ROUTES.myLibraryFavorites.href,
                                        element: <MyLibraryFavoritesPage />
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: ROUTES.loginSSO.href,
                element: <LoginSSOPage />
            },
            {
                element: <AuthGuard />,
                children: [
                    {
                        path: ROUTES.reader.href,
                        element: <ReaderPage />
                    },
                    {
                        path: ROUTES.preview.href,
                        element: <ReaderPage />
                    }
                ]
            },
            {
                path: '*',
                element: <NotFoundPage />
            }
        ]
    }
]);
